import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from 'tss-react/mui';
import { useHistory } from "react-router-dom";
import EAIcon from './EAIcon';

const useStyles = makeStyles()((theme) => ({
  root: {
      cursor: 'pointer',
      display: "flex",
      marginBottom: '6px',
      color: "#9A9AAF",
      width: 'fit-content',
      fontWeight: 700,

      "& p" : {
        position: 'relative',
        top: '2px',
        left: '2px',
        fontWeight: 700,
        color: "#9A9AAF",
        fontSize: "14px",
      }
  },
}));

const EABack = ({ route, params, label }) => {
  const { classes } = useStyles();
  let history = useHistory();

  return (
    <>
      <div className={classes.root} onClick={() => route ? history.push(route, { ...params } ) : history.goBack()}>
        <EAIcon icon={"arrow/arrow-back-navigation"} style={{width:"24px", marginRight: "10px"}}/>
        <Typography variant="body2">
          {label}
        </Typography>
      </div>
    </>
  );
};

export default EABack;
